export default __webpack_public_path__ + "static/media/lamp.b7ebc5f8.png";